// ── TENNESSEE FLAG PROGRESS MAP ENGINE ──────────────────────
// Uses the real Tennessee flag design (from Flag_of_Tennessee.svg)
// Fill advances left→right. At 100% = full TN flag inside state shape.
(function() {
  function renderFlag() {
    var svg = document.getElementById('lp-tn-map-svg');
    if (!svg) return;

    var sponsored = parseInt(svg.getAttribute('data-sponsored') || '25', 10);
    var total = parseInt(svg.getAttribute('data-total') || '95', 10);

    // ViewBox: "-8 115 735 190"
    var VB_X = -8;
    var VB_Y = 115;
    var VB_W = 735;
    var VB_H = 190;
    var CY = VB_Y + VB_H / 2; // ~210

    var pct = Math.min(sponsored / total, 1);
    var fillW = pct * VB_W;
    var fillLeft = VB_X;
    var fillRight = VB_X + fillW;

    // --- Fill clip rect ---
    var el = document.getElementById('lp-fill-rect');
    if (!el) return;
    el.setAttribute('x', fillLeft);
    el.setAttribute('y', VB_Y);
    el.setAttribute('width', fillW);
    el.setAttribute('height', VB_H);

    // --- Red field ---
    document.getElementById('lp-flag-red').setAttribute('x', fillLeft);
    document.getElementById('lp-flag-red').setAttribute('width', fillW);

    // --- Flag proportions (match real TN flag: 240x144, stripe at 222-240) ---
    // White sep: 222/240 = 92.5% of width, width 3/240 = 1.25%
    // Blue stripe: 225/240 = 93.75% of width, width 15/240 = 6.25%
    // Circle center: 111/240 = 46.25% of width, 72/144 = 50% of height
    // Circle radius: 36/240 = 15% of width

    var sepX = fillLeft + fillW * 0.925;
    var sepW = Math.max(fillW * 0.0125, 2);
    var stripeX = sepX + sepW;
    var stripeW = fillRight - stripeX;

    var whiteSep = document.getElementById('lp-flag-white-sep');
    whiteSep.setAttribute('x', sepX);
    whiteSep.setAttribute('width', sepW);

    var blueStripe = document.getElementById('lp-flag-blue-stripe');
    blueStripe.setAttribute('x', stripeX);
    blueStripe.setAttribute('width', Math.max(stripeW, 1));

    // --- Circle + Stars ---
    var circleCX = fillLeft + fillW * 0.4625;
    var circleCY = CY;
    var circleR = Math.max(fillW * 0.08, 10);
    var ringR = circleR * 1.08;

    // Clamp circle so it stays inside red zone (left of white sep)
    circleCX = Math.min(circleCX, sepX - ringR - 2);
    circleCX = Math.max(circleCX, fillLeft + ringR + 2);

    document.getElementById('lp-flag-ring').setAttribute('cx', circleCX);
    document.getElementById('lp-flag-ring').setAttribute('cy', circleCY);
    document.getElementById('lp-flag-ring').setAttribute('r', ringR);

    document.getElementById('lp-flag-circle').setAttribute('cx', circleCX);
    document.getElementById('lp-flag-circle').setAttribute('cy', circleCY);
    document.getElementById('lp-flag-circle').setAttribute('r', circleR);

    // --- Stars: position 3 stars in triangle inside circle ---
    // Orbit radius = 50% of circle radius (stars sit at half-way point)
    // Star scale based on circle size (base design: circle r=22, star size 8)
    var orbit = circleR * 0.5;
    var starScale = circleR / 22;
    // Star 1: top (angle -90°)
    var s1x = circleCX + orbit * Math.cos(-Math.PI / 2);
    var s1y = circleCY + orbit * Math.sin(-Math.PI / 2);
    // Star 2: bottom-right (angle 30°)
    var s2x = circleCX + orbit * Math.cos(Math.PI / 6);
    var s2y = circleCY + orbit * Math.sin(Math.PI / 6);
    // Star 3: bottom-left (angle 150°)
    var s3x = circleCX + orbit * Math.cos(5 * Math.PI / 6);
    var s3y = circleCY + orbit * Math.sin(5 * Math.PI / 6);

    document.getElementById('lp-star1').setAttribute('transform',
      'translate(' + s1x.toFixed(1) + ',' + s1y.toFixed(1) + ') scale(' + starScale.toFixed(3) + ')');
    document.getElementById('lp-star2').setAttribute('transform',
      'translate(' + s2x.toFixed(1) + ',' + s2y.toFixed(1) + ') scale(' + starScale.toFixed(3) + ')');
    document.getElementById('lp-star3').setAttribute('transform',
      'translate(' + s3x.toFixed(1) + ',' + s3y.toFixed(1) + ') scale(' + starScale.toFixed(3) + ')');

    // --- Progress line ---
    var progressLine = document.getElementById('lp-progress-line');
    progressLine.setAttribute('x1', fillRight);
    progressLine.setAttribute('x2', fillRight);
    // Hide line at 100%
    progressLine.setAttribute('opacity', pct >= 1 ? '0' : '1');

    // --- Badge ---
    var badgeW = 110;
    var badgeH = 44;
    var badgeX = Math.max(fillLeft + 4, fillLeft + fillW / 2 - badgeW / 2);
    badgeX = Math.min(badgeX, fillRight - badgeW - 4);
    var badgeY = CY - badgeH / 2;
    var badgeCX = badgeX + badgeW / 2;

    document.getElementById('lp-badge-bg').setAttribute('x', badgeX);
    document.getElementById('lp-badge-bg').setAttribute('y', badgeY);
    document.getElementById('lp-badge-bg').setAttribute('width', badgeW);
    document.getElementById('lp-badge-bg').setAttribute('height', badgeH);
    document.getElementById('lp-badge-count').setAttribute('x', badgeCX);
    document.getElementById('lp-badge-count').setAttribute('y', CY - 2);
    document.getElementById('lp-badge-sub').setAttribute('x', badgeCX);
    document.getElementById('lp-badge-sub').setAttribute('y', CY + 13);

    // Update text
    if (pct >= 1) {
      document.getElementById('lp-badge-count').textContent = '100% COMPLETE';
      document.getElementById('lp-badge-sub').textContent = 'ALL ' + total + ' COUNTIES';
    } else {
      document.getElementById('lp-badge-count').textContent = sponsored + ' SPONSORED';
      document.getElementById('lp-badge-sub').textContent = 'OF ' + total + ' COUNTIES';
    }

    // --- Waiting label ---
    var waitingEl = document.getElementById('lp-waiting-label');
    if (pct >= 1) {
      waitingEl.setAttribute('opacity', '0');
    } else {
      waitingEl.setAttribute('opacity', '1');
      var waitingX = fillRight + (VB_X + VB_W - fillRight) / 2;
      waitingEl.setAttribute('x', waitingX);
      waitingEl.setAttribute('y', CY + 2);
      waitingEl.textContent = (total - sponsored) + ' COUNTIES STILL WAITING';
    }
  }

  document.addEventListener('DOMContentLoaded', renderFlag);

  window.updateTNProgress = function(sponsored, total) {
    var svg = document.getElementById('lp-tn-map-svg');
    if (svg) {
      svg.setAttribute('data-sponsored', sponsored);
      svg.setAttribute('data-total', total);
    }
    renderFlag();
  };
})();
